<div class="card card-flush">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Setting</h3>
    </div>
  </div>
  <div class="card-body pt-0">
    <form [formGroup]="newsLetterSettingsForm" (ngSubmit)="onSubmit()">
      <!-- Company Logo -->
      <div class="fv-row mb-7">
        <label class="form-label">Company Logo</label>
        <div class="d-flex align-items-center">
          <input
            type="file"
            class="form-control form-control-sm"
            style="width: auto;"
            accept="image/*"
            (change)="onFileSelected($event)">
          <span *ngIf="isUploading" class="ms-3">
            <span class="spinner-border spinner-border-sm text-primary" role="status"></span>
          </span>
          <ng-container *ngIf="companyLogoUrl && !isUploading">
            <img [src]="companyLogoUrl" alt="Company Logo" class="ms-3" style="height: 30px; width: auto; cursor: pointer;" (click)="openLogoInNewTab()">
            <button type="button" class="btn btn-icon btn-sm btn-light-danger ms-2" (click)="removeLogo()" title="Remove Logo">
              <i class="ki-duotone ki-cross fs-2">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </button>
          </ng-container>
        </div>
      </div>

      <!-- Bottom Text -->
      <div class="fv-row mb-7">
        <div class="d-flex justify-content-between align-items-center">
          <label class="form-label">Bottom Text</label>
          <span class="text-muted fs-7">({{ bottomTextLength }} / {{ maxBottomTextLength }})</span>
        </div>
        <textarea
          formControlName="bottom_text"
          class="form-control"
          rows="6"
          placeholder="Enter bottom text"
          [maxlength]="maxBottomTextLength">
        </textarea>
      </div>

      <!-- Submit Button -->
      <div class="d-flex justify-content-start">
        <button
          type="submit"
          class="btn btn-sm btn-primary"
          [disabled]="isLoading || isUploading">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {{ isLoading ? 'Submitting...' : 'Submit' }}
        </button>
      </div>
    </form>
  </div>
</div>
